
export enum AuthType {
  LOGOUT,
  LOGIN,
  SITE_SWITCH,
  DISTUSER_NO_SITE_DESTINY_HACK
}

export default AuthType;
